import React from 'react';

import MInput from 'views/MInput/MInput';

type Props = {
  name: string;
  invalid?: boolean;
  disabled?: boolean;
  value: string | number;
  type?: string;
  className?: string;
  min?: string;
  max?: string;
  step?: string;
  placeholder?: string;
  autoComplete?: string;
  inputClassName?: string;
  ignoreInvalidIcon?: boolean;
  startIcon?: JSX.Element | null;
  endIcon?: JSX.Element | null;
  tabIndex?: number;
  autoSelectOnFocus?: boolean;
  onInput?: (event: React.ChangeEvent<HTMLInputElement>) => string;
  onFocus?: () => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
};

const MFormInputView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MInput
      name={props.name}
      invalid={props.invalid}
      disabled={props.disabled}
      value={props.value}
      type={props.type}
      startIcon={props.startIcon}
      endIcon={props.endIcon}
      className={props.className}
      min={props.min}
      max={props.max}
      step={props.step}
      placeholder={props.placeholder}
      autoComplete={props.autoComplete}
      inputClassName={props.inputClassName}
      ignoreInvalidIcon={props.ignoreInvalidIcon}
      tabIndex={props.tabIndex}
      autoSelectOnFocus={props.autoSelectOnFocus}
      onInput={props.onInput}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      onChange={props.onChange}
    />
  );
};

MFormInputView.displayName = 'MFormInputView';
MFormInputView.defaultProps = {};

export default MFormInputView;
